import React from 'react';
import AdminDashboard from '../components/admin/Dashboard';

const AdminDashboardPage = () => {
  return <AdminDashboard />;
};

export default AdminDashboardPage;